module.exports = __webpack_public_path__ + "img/expand.93b7e488.svg";